import { createSlice } from "@reduxjs/toolkit";

interface EmployeeInactivePageInterface {
    currentPage: number;
    itemsPerPage: number;
    searchTerm: string;
    itemsPerPageSelect: { value: number; activeValue: boolean }[];
    isLeftTagOpenIndex: number;
    isRightTagOpenIndex: number;
    isCheckboxChecked: boolean;
    isDeleteAccountModalOpen: boolean;
}

const initialState: EmployeeInactivePageInterface = {
    currentPage: 1,
    itemsPerPage: 12,
    searchTerm: "",
    itemsPerPageSelect: [
        { value: 12, activeValue: true },
        { value: 25, activeValue: false },
        { value: 50, activeValue: false },
    ],
    isLeftTagOpenIndex: -1,
    isRightTagOpenIndex: -1,
    isCheckboxChecked: false,
    isDeleteAccountModalOpen: false,
};

const employeeInactiveSlice = createSlice({
    name: "employeeInactive",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setItemsPerPage: (state, action) => {
            state.itemsPerPage = action.payload;

            state.itemsPerPageSelect = state.itemsPerPageSelect.map((item) => {
                return {
                    ...item,
                    activeValue: item.value === action.payload,
                };
            });
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        setIsLeftTagOpenIndex: (state, action) => {
            state.isLeftTagOpenIndex = action.payload;
        },
        setIsRightTagOpenIndex: (state, action) => {
            state.isRightTagOpenIndex = action.payload;
        },
        setIsCheckboxChecked: (state, action) => {
            state.isCheckboxChecked = action.payload;
        },
        setIsDeleteAccountModalOpen: (state, action) => {
            state.isDeleteAccountModalOpen = action.payload;
        },
    },
});

export const employeeInactiveReducer = employeeInactiveSlice.reducer;

export const {
    setItemsPerPage,
    setCurrentPage,
    setSearchTerm,
    setIsRightTagOpenIndex,
    setIsLeftTagOpenIndex,
    setIsCheckboxChecked,
    setIsDeleteAccountModalOpen,
} = employeeInactiveSlice.actions;
